/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { AddFinancialPeriodRequest } from "../model"
// @ts-ignore
import type { ApiAllPeriods } from "../model"
// @ts-ignore
import type { ApiFinancialPeriod } from "../model"
// @ts-ignore
import type { InitFinancialPeriodsRequest } from "../model"
// @ts-ignore
import type { SaveFinancialPeriodRequest } from "../model"
// @ts-ignore
import type { UpdateFinancialPeriodDatesRequest } from "../model"
/**
 * FinancialPeriodResourceV2Api - axios parameter creator
 */
export const FinancialPeriodResourceV2ApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Add a financial period
     * @param {AddFinancialPeriodRequest} addFinancialPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFinancialPeriod: async (
      addFinancialPeriodRequest: AddFinancialPeriodRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'addFinancialPeriodRequest' is not null or undefined
      assertParamExists(
        "addFinancialPeriod",
        "addFinancialPeriodRequest",
        addFinancialPeriodRequest
      )
      const localVarPath = `/v2.0/financialPeriods`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addFinancialPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete a financial period
     * @param {number} financialPeriodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFinancialPeriod: async (
      financialPeriodId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'financialPeriodId' is not null or undefined
      assertParamExists("deleteFinancialPeriod", "financialPeriodId", financialPeriodId)
      const localVarPath = `/v2.0/financialPeriods/{financialPeriodId}`.replace(
        "{financialPeriodId}",
        encodeURIComponent(String(financialPeriodId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Fixes financial periods details entry id problems
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fixFinancialPeriodsDetails: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("fixFinancialPeriodsDetails", "noteId", noteId)
      const localVarPath = `/v2.0/financialPeriods/reinit-details`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (noteId !== undefined) {
        localVarQueryParameter["noteId"] = noteId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getApiAllPeriods: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getApiAllPeriods", "noteId", noteId)
      const localVarPath = `/v2.0/financialPeriods`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (noteId !== undefined) {
        localVarQueryParameter["noteId"] = noteId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFinancialPeriods: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getFinancialPeriods", "noteId", noteId)
      const localVarPath = `/v2.0/financialPeriods/raw`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (noteId !== undefined) {
        localVarQueryParameter["noteId"] = noteId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Init financial periods
     * @param {InitFinancialPeriodsRequest} initFinancialPeriodsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initFinancialPeriods: async (
      initFinancialPeriodsRequest: InitFinancialPeriodsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'initFinancialPeriodsRequest' is not null or undefined
      assertParamExists(
        "initFinancialPeriods",
        "initFinancialPeriodsRequest",
        initFinancialPeriodsRequest
      )
      const localVarPath = `/v2.0/financialPeriods/init`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        initFinancialPeriodsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Shift first forecast period to last previous period
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shiftFirstForecastToLastPreviousPeriod: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("shiftFirstForecastToLastPreviousPeriod", "noteId", noteId)
      const localVarPath = `/v2.0/financialPeriods/shift-first-forecast`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (noteId !== undefined) {
        localVarQueryParameter["noteId"] = noteId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update a financial period\'s dates
     * @param {number} financialPeriodId
     * @param {UpdateFinancialPeriodDatesRequest} updateFinancialPeriodDatesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialPeriodDates: async (
      financialPeriodId: number,
      updateFinancialPeriodDatesRequest: UpdateFinancialPeriodDatesRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'financialPeriodId' is not null or undefined
      assertParamExists("updateFinancialPeriodDates", "financialPeriodId", financialPeriodId)
      // verify required parameter 'updateFinancialPeriodDatesRequest' is not null or undefined
      assertParamExists(
        "updateFinancialPeriodDates",
        "updateFinancialPeriodDatesRequest",
        updateFinancialPeriodDatesRequest
      )
      const localVarPath = `/v2.0/financialPeriods/{financialPeriodId}/dates`.replace(
        "{financialPeriodId}",
        encodeURIComponent(String(financialPeriodId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFinancialPeriodDatesRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update a financial period
     * @param {string} noteId
     * @param {Array<SaveFinancialPeriodRequest>} saveFinancialPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialPeriods: async (
      noteId: string,
      saveFinancialPeriodRequest: Array<SaveFinancialPeriodRequest>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("updateFinancialPeriods", "noteId", noteId)
      // verify required parameter 'saveFinancialPeriodRequest' is not null or undefined
      assertParamExists(
        "updateFinancialPeriods",
        "saveFinancialPeriodRequest",
        saveFinancialPeriodRequest
      )
      const localVarPath = `/v2.0/financialPeriods/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveFinancialPeriodRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FinancialPeriodResourceV2Api - functional programming interface
 */
export const FinancialPeriodResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FinancialPeriodResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Add a financial period
     * @param {AddFinancialPeriodRequest} addFinancialPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFinancialPeriod(
      addFinancialPeriodRequest: AddFinancialPeriodRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addFinancialPeriod(
        addFinancialPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.addFinancialPeriod"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a financial period
     * @param {number} financialPeriodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteFinancialPeriod(
      financialPeriodId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFinancialPeriod(
        financialPeriodId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.deleteFinancialPeriod"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Fixes financial periods details entry id problems
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fixFinancialPeriodsDetails(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fixFinancialPeriodsDetails(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.fixFinancialPeriodsDetails"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getApiAllPeriods(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAllPeriods>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getApiAllPeriods(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.getApiAllPeriods"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFinancialPeriods(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getFinancialPeriods(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.getFinancialPeriods"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Init financial periods
     * @param {InitFinancialPeriodsRequest} initFinancialPeriodsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initFinancialPeriods(
      initFinancialPeriodsRequest: InitFinancialPeriodsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initFinancialPeriods(
        initFinancialPeriodsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.initFinancialPeriods"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Shift first forecast period to last previous period
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async shiftFirstForecastToLastPreviousPeriod(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.shiftFirstForecastToLastPreviousPeriod(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.shiftFirstForecastToLastPreviousPeriod"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a financial period\'s dates
     * @param {number} financialPeriodId
     * @param {UpdateFinancialPeriodDatesRequest} updateFinancialPeriodDatesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFinancialPeriodDates(
      financialPeriodId: number,
      updateFinancialPeriodDatesRequest: UpdateFinancialPeriodDatesRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialPeriodDates(
        financialPeriodId,
        updateFinancialPeriodDatesRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.updateFinancialPeriodDates"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a financial period
     * @param {string} noteId
     * @param {Array<SaveFinancialPeriodRequest>} saveFinancialPeriodRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFinancialPeriods(
      noteId: string,
      saveFinancialPeriodRequest: Array<SaveFinancialPeriodRequest>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiFinancialPeriod>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialPeriods(
        noteId,
        saveFinancialPeriodRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["FinancialPeriodResourceV2Api.updateFinancialPeriods"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FinancialPeriodResourceV2Api - factory interface
 */
export const FinancialPeriodResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FinancialPeriodResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Add a financial period
     * @param {FinancialPeriodResourceV2ApiAddFinancialPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFinancialPeriod(
      requestParameters: FinancialPeriodResourceV2ApiAddFinancialPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .addFinancialPeriod(requestParameters.addFinancialPeriodRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a financial period
     * @param {FinancialPeriodResourceV2ApiDeleteFinancialPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFinancialPeriod(
      requestParameters: FinancialPeriodResourceV2ApiDeleteFinancialPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteFinancialPeriod(requestParameters.financialPeriodId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Fixes financial periods details entry id problems
     * @param {FinancialPeriodResourceV2ApiFixFinancialPeriodsDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fixFinancialPeriodsDetails(
      requestParameters: FinancialPeriodResourceV2ApiFixFinancialPeriodsDetailsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .fixFinancialPeriodsDetails(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {FinancialPeriodResourceV2ApiGetApiAllPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getApiAllPeriods(
      requestParameters: FinancialPeriodResourceV2ApiGetApiAllPeriodsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ApiAllPeriods> {
      return localVarFp
        .getApiAllPeriods(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get all financial periods by note id
     * @param {FinancialPeriodResourceV2ApiGetFinancialPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFinancialPeriods(
      requestParameters: FinancialPeriodResourceV2ApiGetFinancialPeriodsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .getFinancialPeriods(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Init financial periods
     * @param {FinancialPeriodResourceV2ApiInitFinancialPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initFinancialPeriods(
      requestParameters: FinancialPeriodResourceV2ApiInitFinancialPeriodsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .initFinancialPeriods(requestParameters.initFinancialPeriodsRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Shift first forecast period to last previous period
     * @param {FinancialPeriodResourceV2ApiShiftFirstForecastToLastPreviousPeriodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shiftFirstForecastToLastPreviousPeriod(
      requestParameters: FinancialPeriodResourceV2ApiShiftFirstForecastToLastPreviousPeriodRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .shiftFirstForecastToLastPreviousPeriod(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update a financial period\'s dates
     * @param {FinancialPeriodResourceV2ApiUpdateFinancialPeriodDatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialPeriodDates(
      requestParameters: FinancialPeriodResourceV2ApiUpdateFinancialPeriodDatesRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .updateFinancialPeriodDates(
          requestParameters.financialPeriodId,
          requestParameters.updateFinancialPeriodDatesRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update a financial period
     * @param {FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialPeriods(
      requestParameters: FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ApiFinancialPeriod>> {
      return localVarFp
        .updateFinancialPeriods(
          requestParameters.noteId,
          requestParameters.saveFinancialPeriodRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addFinancialPeriod operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiAddFinancialPeriodRequest {
  readonly addFinancialPeriodRequest: AddFinancialPeriodRequest
}

/**
 * Request parameters for deleteFinancialPeriod operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiDeleteFinancialPeriodRequest {
  readonly financialPeriodId: number
}

/**
 * Request parameters for fixFinancialPeriodsDetails operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiFixFinancialPeriodsDetailsRequest {
  readonly noteId: string
}

/**
 * Request parameters for getApiAllPeriods operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiGetApiAllPeriodsRequest {
  readonly noteId: string
}

/**
 * Request parameters for getFinancialPeriods operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiGetFinancialPeriodsRequest {
  readonly noteId: string
}

/**
 * Request parameters for initFinancialPeriods operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiInitFinancialPeriodsRequest {
  readonly initFinancialPeriodsRequest: InitFinancialPeriodsRequest
}

/**
 * Request parameters for shiftFirstForecastToLastPreviousPeriod operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiShiftFirstForecastToLastPreviousPeriodRequest {
  readonly noteId: string
}

/**
 * Request parameters for updateFinancialPeriodDates operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiUpdateFinancialPeriodDatesRequest {
  readonly financialPeriodId: number

  readonly updateFinancialPeriodDatesRequest: UpdateFinancialPeriodDatesRequest
}

/**
 * Request parameters for updateFinancialPeriods operation in FinancialPeriodResourceV2Api.
 */
export interface FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest {
  readonly noteId: string

  readonly saveFinancialPeriodRequest: Array<SaveFinancialPeriodRequest>
}

/**
 * FinancialPeriodResourceV2Api - object-oriented interface
 */
export class FinancialPeriodResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Add a financial period
   * @param {FinancialPeriodResourceV2ApiAddFinancialPeriodRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addFinancialPeriod(
    requestParameters: FinancialPeriodResourceV2ApiAddFinancialPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .addFinancialPeriod(requestParameters.addFinancialPeriodRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a financial period
   * @param {FinancialPeriodResourceV2ApiDeleteFinancialPeriodRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteFinancialPeriod(
    requestParameters: FinancialPeriodResourceV2ApiDeleteFinancialPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .deleteFinancialPeriod(requestParameters.financialPeriodId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Fixes financial periods details entry id problems
   * @param {FinancialPeriodResourceV2ApiFixFinancialPeriodsDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public fixFinancialPeriodsDetails(
    requestParameters: FinancialPeriodResourceV2ApiFixFinancialPeriodsDetailsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .fixFinancialPeriodsDetails(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all financial periods by note id
   * @param {FinancialPeriodResourceV2ApiGetApiAllPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public getApiAllPeriods(
    requestParameters: FinancialPeriodResourceV2ApiGetApiAllPeriodsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .getApiAllPeriods(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all financial periods by note id
   * @param {FinancialPeriodResourceV2ApiGetFinancialPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getFinancialPeriods(
    requestParameters: FinancialPeriodResourceV2ApiGetFinancialPeriodsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .getFinancialPeriods(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Init financial periods
   * @param {FinancialPeriodResourceV2ApiInitFinancialPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public initFinancialPeriods(
    requestParameters: FinancialPeriodResourceV2ApiInitFinancialPeriodsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .initFinancialPeriods(requestParameters.initFinancialPeriodsRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Shift first forecast period to last previous period
   * @param {FinancialPeriodResourceV2ApiShiftFirstForecastToLastPreviousPeriodRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public shiftFirstForecastToLastPreviousPeriod(
    requestParameters: FinancialPeriodResourceV2ApiShiftFirstForecastToLastPreviousPeriodRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .shiftFirstForecastToLastPreviousPeriod(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a financial period\'s dates
   * @param {FinancialPeriodResourceV2ApiUpdateFinancialPeriodDatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateFinancialPeriodDates(
    requestParameters: FinancialPeriodResourceV2ApiUpdateFinancialPeriodDatesRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .updateFinancialPeriodDates(
        requestParameters.financialPeriodId,
        requestParameters.updateFinancialPeriodDatesRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a financial period
   * @param {FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateFinancialPeriods(
    requestParameters: FinancialPeriodResourceV2ApiUpdateFinancialPeriodsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return FinancialPeriodResourceV2ApiFp(this.configuration)
      .updateFinancialPeriods(
        requestParameters.noteId,
        requestParameters.saveFinancialPeriodRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
